import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=87872e0a&scoped=true&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87872e0a",
  null
  
)

export default component.exports